import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'

import LessonsPicker from 'views/modals/lessons_picker_modal'

import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import privateLibraryActions from 'redux/actions/privateLibraryActions'

import { privateLibrarySelectors } from 'redux/selectors'

class PrivateLibraryLessonsPickerModal extends Component {

	componentDidMount() {
		this.props.actions.init()
	}

	searchLessons() {
		this.props.actions.searchLessons()
	}

	render() {
		return (
			<LessonsPicker
				modalName={this.props.modalName}
				folderName={this.props.folderName}
				placeholder={this.props.placeholder}
				showType={true}
				showPrice={true}
				closeModal={this.props.actions.cancel}
				searchLessons={this.props.actions.searchLessons}
				saveLessons={this.props.actions.saveLessons}
				cancel={this.props.actions.cancel} />
		)
	}
}

PrivateLibraryLessonsPickerModal.propTypes = {
	modalName: PropTypes.string,
	entityUID: PropTypes.string,
}

function mapStateToProps(state) {
	return privateLibrarySelectors.lessonsPickerModalView(state)
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		init: privateLibraryActions.lessonsPickerInit,
		searchLessons: privateLibraryActions.lessonsPickerSearchLessons,
		saveLessons: privateLibraryActions.lessonsPickerSaveLessons,
		cancel: privateLibraryActions.lessonsPickerCancel,
	}, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(PrivateLibraryLessonsPickerModal)
